import {StorageKey} from "../../../../enums/StorageKey";
import {t} from "@lingui/macro";

export default {
    storageKey: StorageKey.report_trial_balance,
    getReportLabel: () => t`Trial Balance`,
    getColumns: () => [],
};
